import { useState } from 'react';
import AuthService from '../services/AuthService';

const useForgotPasswordViewModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const forgotPassword = async (email) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await AuthService.forgotPassword(email);
      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    forgotPassword,
  };
};

export default useForgotPasswordViewModel;